import { FC } from "react";
import { useTranslation } from "react-i18next";

/**
 * Caption, column widths and column names of the preview table. They are one unit: every `col` here
 * has exactly one `th` below it, so the two can only stay in step while they are edited together.
 */
export const StationTimingPreviewTableHead: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <caption className="station-timing__caption">
        {t("stationTiming.CAPTION")}
      </caption>
      <colgroup>
        <col className="station-timing__col-leg" />
        <col className="station-timing__col-planned" />
        <col className="station-timing__col-measure" />
        <col className="station-timing__col-delta" />
        <col className="station-timing__col-based-on" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">{t("stationTiming.COLUMN_LEG")}</th>
          <th scope="col" className="station-timing__head-end">
            {t("stationTiming.COLUMN_PLANNED")}
          </th>
          <th scope="col">{t("stationTiming.COLUMN_MEASURED")}</th>
          <th scope="col" className="station-timing__head-end">
            {t("stationTiming.COLUMN_VS_PLANNED")}
          </th>
          <th scope="col" className="station-timing__head-end">
            {t("stationTiming.COLUMN_BASED_ON")}
          </th>
        </tr>
      </thead>
    </>
  );
};
